import { useQuery } from 'react-query';
import CompanyService from 'App/services/CompanyService';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { PERMISSION_TYPES } from 'App/utils/isPermitted';

function useFetchBranchesQuery() {
    const isSsoEnabled = useIsPermitted(PERMISSION_TYPES.SSO_ENABLED);
    return useQuery(
        ['company', 'users', 'pendingActivation'],
        isSsoEnabled ? CompanyService.getPendingCompanySsoUsers : () => Promise.resolve([]),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchBranchesQuery;
